export default ({ value, singular, plural }) => (parseInt(value, 10) === 1 ? singular : plural)
